import React from 'react'

const Empty = ({ children }) => <>{children}</>

Empty.propTypes = {}

Empty.defaultProps = {}

export default Empty
